import { render, staticRenderFns } from "./WorkbookGrid.vue?vue&type=template&id=5b122952&scoped=true"
import script from "./WorkbookGrid.vue?vue&type=script&lang=js"
export * from "./WorkbookGrid.vue?vue&type=script&lang=js"
import style0 from "./WorkbookGrid.vue?vue&type=style&index=0&id=5b122952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b122952",
  null
  
)

export default component.exports